/**
 * The URL for an uploaded image, optionally at a smaller size.
 *
 * `width` asks the server for a cached derivative, and for product images that
 * derivative is also padded to a square — which is the point of using it here
 * rather than the raw upload. The card and the detail gallery are both 1:1
 * (`aspect-ratio: 1 / 1` in VegetableCard.css and VegetableDetailPage.css), so
 * an unpadded photo is centre-cropped by `object-fit: cover`, and the
 * catalogue's shapes run from 0.75:1 to 1.79:1 — up to 46% of some images was
 * being thrown away.
 *
 * Only 200, 400 and 800 exist. The server ignores anything else and serves the
 * original, so an unlisted width degrades to the previous behaviour rather
 * than breaking.
 *
 * Mirrors onlinesabjiwala-mobile/utils/imageUrl.ts, deliberately: the two
 * clients should ask for the same file, or they cache and render differently.
 */
export function imageUrl(path?: string | null, width?: 200 | 400 | 800): string | undefined {
  if (!path) return undefined;
  if (!width) return path;
  // Someone else's host knows nothing about ?w=.
  if (/^https?:\/\//i.test(path)) return path;
  return `${path}${path.includes('?') ? '&' : '?'}w=${width}`;
}
